import {useQuery} from "@tanstack/react-query";
import axios from "axios";
import {MenuMaster} from "../../../models/config/MenuMaster";
import {ResponseList} from "../../../models/common/Response";

export type UseMasterMenuProps = {
    enabled?: boolean;
    sid?: string;
    id?: string;
    menuName?: string;
} 

export const useMenuMaster = (props?: UseMasterMenuProps) => {
    const { enabled, sid, id, menuName } = props || {};
    
    return useQuery({
        enabled,
        queryKey: ['menu-master', { sid, id, menuName }],
        queryFn: ({ signal }) => {
            const accessToken = localStorage.getItem('LG_APPLICATION');
            
            return axios.get<ResponseList<MenuMaster>>(
                '/v1/configuration/lis/menu',
                {
                    signal,
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    },
                    params: {
                        sid,
                        id,
                        menu_name: menuName,
                    }
                }
            );
        },
        select: (response) => response.data.result_list,
        retry: 1
    });
}